import React, { FC } from 'react'
import { StyledContent } from './styles'
import { Content } from '../../../components/content/Content'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

const ContactPage: FC = () => {
	return (
		<PublicLayout>
			<StyledContent>
				<Content slug={'kontakt'} />
			</StyledContent>
		</PublicLayout>
	)
}

export default ContactPage
